import _ from "lodash";
import React, { useState } from "react";
import { Form } from "react-final-form";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../components/DetailedErrorAlert";
import { adminApi as api, extractErrorMessage } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { FeeScheduleByPayorForm } from "./FeeScheduleByPayorForm";

export const CreateLabFeeScheduleByPayorModal = ({ labId, onCreate, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen(!open);

  const handleCreate = async (values) => {
    const newValues = _.cloneDeep(values);

    setError(null);
    try {
      const res = await api.post("/admin/cpt_fee_schedules", { cpt_fee_schedule: snakifyKeys(newValues) });

      if (onCreate) {
        onCreate(res.data.resource);
      }

      setOpen(false);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Add CPT Fee Schedule By Payor
      </Button>

      <Modal isOpen={open} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>Add CPT Fee Schedule By Payor</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleCreate} initialValues={{ labId }}>
            {(props) => <FeeScheduleByPayorForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
